var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoErecruiterSymbolDark = function SvgLogoErecruiterSymbolDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 24,
    fill: "none",
    viewBox: "0 0 60 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#64D7DC",
    d: "M35.996 12a12 12 0 1 0 24.001 0 12 12 0 0 0-24.001 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 12a12 12 0 1 0 24 0 12 12 0 0 0-24 0"
  })));
};
export default SvgLogoErecruiterSymbolDark;